import { IReportGroup } from "../../../../reporting/interfaces/IReportGroup";
import { Machine } from "../../models/machine";
import {
  MachineConfiguration,
  MachineGameConfiguration,
} from "../../models/machineConfiguration";
import {
  MachinesChangeViewModalService,
  vsServiceName as MachinesChangeViewModalServiceName,
} from "../changeDetailsModel";

export class MachineConfigurationViewComponentController {
  static $inject = [MachinesChangeViewModalServiceName];
  readonly machine!: Machine;
  readonly machineConfiguration!: MachineConfiguration;
  readonly reportGroup!: IReportGroup;
  conversionModalService: any;
  $state: any;
  gridSelection: any;
  constructor(
    private readonly MachinesChangeViewModalService: MachinesChangeViewModalService
  ) {}
  $onInit() {}

  getGameProgramNumber(gameConfig: MachineGameConfiguration) {
    return (
      (gameConfig.GameProgramNumber === undefined
        ? ""
        : `${gameConfig.GameProgramNumber} `) +
      (gameConfig.GameProgramVersion ?? "")
    );
  }

  async ChangeLog(): Promise<void> {
    const modalInstance = this.MachinesChangeViewModalService.openModal(
      this.machineConfiguration?.ChangeId
    );
    const result = await modalInstance.result;
    let cloneConfiguration: any = {};
  }
}
